const ProgressCta = ({ width }) => (
  <div className="outer">
    <div
      className="inner"
      style={{
        width: `${width}%`
      }}
    />
  </div>
);

export default ProgressCta;
